import { render } from "./SysModelDescDialog.vue?vue&type=template&id=4441d05c"
import script from "./SysModelDescDialog.vue?vue&type=script&lang=js"
export * from "./SysModelDescDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__